<template>
  <div>
    <div class="vue-step-wrapper">
      <vue-step
        style-type="style2"
        active-color="#4ce595"
        :now-step="3"
        :step-list="[
          $t('newAction.stepsLabels.selectMetric'),
          $t('newAction.stepsLabels.stepOne'),
          $t('newAction.stepsLabels.stepTwo'),
          $t('newAction.stepsLabels.stepThree'),
        ]"
      ></vue-step>
    </div>

    <div class="wrapper">
      <div v-if="loading" class="row mt-4 mb-4 loading-area">
        <div class="col-12">
          <div class="text-center text-primary my-2">
            <b-spinner type="grow" class="align-middle"></b-spinner>
          </div>
        </div>
      </div>
      <div v-else class="mt-4 mb-4">
        <div class="row">
          <div :class="classConfigs">
            <div class="row">
              <div class="col-12">
                <idx-card
                  class="mb-4"
                  :title="`${this.$t('newAction.nameAction')}`"
                >
                  <input
                    type="text"
                    :value="action.name"
                    id="action-name-id"
                    class="form-control"
                    disabled="disabled"
                  />
                </idx-card>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <idx-card
                  :title="`${this.$t('newAction.stepTwo.titleSetting')}`"
                >
                  <div class="row">
                    <div class="col-12">
                      <div class="table-step-two">
                        <b-table
                          striped
                          :fields="fields"
                          :items="listRules"
                          :busy="loadingModalRule"
                        >
                          <template v-slot:table-busy>
                            <div class="text-center text-primary my-2">
                              <b-spinner
                                type="grow"
                                class="align-middle"
                              ></b-spinner>
                            </div>
                          </template>
                          <template v-slot:cell(_id)="row">
                            <div style="width: 5px">
                              <div
                                class="custom-control custom-radio my-1 mr-sm-2"
                              >
                                <input
                                  @click="
                                    chooseRule($event.target.value, row.index)
                                  "
                                  type="radio"
                                  class="custom-control-input"
                                  :value="row.item._id"
                                  :id="`select-rule-${row.index}`"
                                  :checked="
                                    row.item._id === action.alertRules.id
                                      ? true
                                      : false
                                  "
                                />
                                <label
                                  class="custom-control-label"
                                  :for="`select-rule-${row.index}`"
                                ></label>
                              </div>
                            </div>
                          </template>
                          <template v-slot:cell(createdAt)="row">
                            {{ dateFormat(new Date(row.item.createdAt)) }}
                          </template>
                          <template v-slot:cell(action)="row">
                            <div class="text-right">
                              <button
                                class="btn btn-outline-primary"
                                v-b-modal="`modal-edit-rule-${row.index}`"
                              >
                                <font-awesome-icon :icon="['fas', 'pen']" />
                              </button>
                            </div>
                            <modal-edit-rule
                              :ruleId="row.index"
                              :rule="row.item"
                            />
                          </template>
                        </b-table>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 mt-auto mb-auto">
                      <span class="font-italic">
                        {{ $t('newAction.stepTwo.selectedRule') }}:
                        {{
                          ruleName
                            ? ruleName
                            : this.$t('newAction.stepTwo.noRule')
                        }}
                      </span>
                    </div>
                    <div class="col-6">
                      <div class="mt-2 text-right">
                        <button
                          class="btn btn-outline-primary"
                          v-b-modal="`modal-new-rule`"
                        >
                          {{ $t('newAction.stepTwo.newRule') }}
                        </button>
                        <button
                          class="btn btn-outline-danger"
                          @click="chooseRule(false, false, true)"
                        >
                          {{ $t('newAction.stepTwo.noRule') }}
                        </button>
                        <modal-new-rule :actionId="action._id" />
                      </div>
                    </div>
                  </div>
                </idx-card>
              </div>
            </div>
            <div class="row mt-4" v-if="company.enableKeywordAlert">
              <div class="col-12">
                <idx-card
                  :title="`CONFIGURAÇÃO DE ALERTA POR PALAVRA CHAVE`"
                  :showButtonAlertByKey="false"
                >
                  <div class="row">
                    <div class="col-12">
                      <div v-if="!loadingRuleKeyword" class="table-step-two">
                        <b-table
                          striped
                          :fields="fieldsKeywords"
                          :items="listRuleByKeywords"
                          :busy="loadingModalRule"
                        >
                          <template v-slot:table-busy>
                            <div class="text-center text-primary my-2">
                              <b-spinner
                                type="grow"
                                class="align-middle"
                              ></b-spinner>
                            </div>
                          </template>
                          <template v-slot:cell(_id)="row">
                            <div style="width: 5px">
                              <div
                                class="custom-control custom-radio my-1 mr-sm-2"
                              >
                                <input
                                  @click="
                                    chooseRuleKeywords(
                                      row.item._id,
                                      row.index,
                                    )
                                  "
                                  type="radio"
                                  class="custom-control-input"
                                  :value="row.item._id"
                                  :id="`rule-keywords-${row.index}`"
                                  :checked="
                                    row.item._id ===
                                    action.keywordsAlertId
                                      ? true
                                      : false
                                  "
                                  :name="'rule-keywords-group'"
                                />
                                <label
                                  class="custom-control-label"
                                  :for="`rule-keywords-${row.index}`"
                                ></label>
                              </div>
                            </div>
                          </template>
                          <template v-slot:cell(createdAt)="row">
                            {{ row.item.createdAt ? dateFormat(new Date(row.item.createdAt)) : '-' }}
                          </template>
                          <template v-slot:cell(action)="row">
                            <div class="text-right">
                              <button
                                class="btn btn-outline-primary"
                                v-b-modal="`modal-new-rule-keyword-edit-${row.index}`"
                                @click="getDataRule(row.item)"
                              >
                                <font-awesome-icon :icon="['fas', 'pen']" />
                              </button>
                            </div>
                            <modal-edit-rule-keyword
                              :ruleIndex="row.index"
                              :rule="row.item"
                            />
                          </template>
                        </b-table>
                      </div>
                      <div v-else>
                        <b-spinner
                          variant="primary"
                          type="grow"
                          class="align-middle"
                        ></b-spinner>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 mt-auto mb-auto">
                      <span class="font-italic">
                        {{ $t('newAction.stepTwo.selectedRule') }}:
                        {{
                          ruleNameByKeyword
                            ? ruleNameByKeyword
                            : this.$t('newAction.stepTwo.noRule')
                        }}
                      </span>
                    </div>
                    <div class="col-6">
                      <div class="mt-2 text-right">
                        <button
                          class="btn btn-outline-primary"
                          v-b-modal="`modal-new-rule-keyword`"
                        >
                          {{ $t('newAction.stepTwo.newRule') }}
                        </button>
                        <button
                          class="btn btn-outline-danger"
                          @click="chooseRuleKeywords(false, false, true)"
                        >
                          {{ $t('newAction.stepTwo.noRule') }}
                        </button>
                        <modal-new-rule-keyword :actionId="action._id" />
                      </div>
                    </div>
                  </div>
                </idx-card>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <idx-card
                  :title="`${this.$t('newAction.stepTwo.reminderSetting')}`"
                  class="mt-4"
                  v-if="
                    action.channel !== 'click-to-call' &&
                    action.channel !== 'widget'
                  "
                >
                <div class="p-4">
                  <h6>A criação de lembretes deve ser feita na nova versão da INDECX</h6>
                  <br>
                  <button @click="getV3()" class="btn btn-primary">Ir para nova versão </button>
                </div>
                  <!-- <div class="row">
                    <div class="col-4 mt-auto">
                      <div class="form-group">
                        <label for="reminders-qty"
                          >{{ $t('newAction.stepTwo.labels.amount') }}:</label
                        >
                        <input
                          type="number"
                          class="form-control"
                          id="reminders-qty"
                          v-model="action.alertRules.reminders"
                          @keyup="setAlertRuleReminders($event.target.value)"
                        />
                      </div>
                    </div>
                    <div class="col-4 mt-auto">
                      <div class="form-group">
                        <label for="time"
                          >{{ $t('newAction.stepTwo.labels.schedule') }}:</label
                        >
                        <b-form-select
                          id="time"
                          v-model="timeSelected"
                          :options="timeOptions"
                          @change="setAlertRuleTime($event)"
                        ></b-form-select>
                      </div>
                    </div>
                    <div class="col-4 mt-auto">
                      <div class="form-group">
                        <label for="reminders-interval"
                          >{{
                            $t('newAction.stepTwo.labels.intervalDays')
                          }}:</label
                        >
                        <input
                          type="number"
                          class="form-control"
                          id="reminders-interval"
                          v-model="action.alertRules.interval"
                          @keyup="setAlertRuleInterval($event.target.value)"
                        />
                      </div>
                    </div>
                  </div> -->
                  <!-- <div
                    v-if="
                      action.channel === 'email' &&
                      userAuth.companyId !== '5d8ba15696fa442270173557'
                    "
                  >
                    <div style="display: flex">
                      <div class="col-4">
                        <b>{{ $t('newAction.stepTwo.enableSMS') }}</b> <br />
                        <b-form-radio-group
                          v-model="smsReminder"
                          :options="optionsRadio"
                          class="mb-3"
                          value-field="item"
                          text-field="name"
                        ></b-form-radio-group>
                      </div>
                      <div class="col-8 text-center" v-if="smsReminder">
                        <div class="msg-reminder">
                          {{ $t('newAction.stepTwo.msgReminder') }}
                        </div>
                      </div>
                    </div>

                    <div v-if="smsReminder">
                      <span>{{ $t('newAction.stepTwo.typeMesssage') }}:</span>
                      <b-input-group
                        append="https://id-cx.co/8dígitos"
                        class="mb-2 mr-sm-2 mb-sm-0"
                      >
                        <b-input
                          v-model="action.sms.msgLink"
                          id="message-link-id"
                          style="box-shadow: none"
                          placeholder="Responda a nossa pesquisa aqui:"
                          maxlength="130"
                        ></b-input>
                      </b-input-group>
                    </div>
                  </div> -->

                  <!-- custom reminder -->
                  <!-- <div
                    v-if="
                      action.channel === 'email' &&
                      userAuth.companyId === '5d8ba15696fa442270173557'
                    "
                  >
                    <div style="display: flex">
                      <div class="col-6">
                        <div class="form-group" style="display: flex">
                          <span>{{ $t('newAction.stepTwo.enableSMS') }}</span>
                          <b-form-checkbox
                            class="ml-2"
                            name="check-shot"
                            v-model="enableCustomReminder"
                            switch
                          >
                          </b-form-checkbox>
                        </div>

                        <b-form-radio-group
                          v-show="enableCustomReminder"
                          v-model="action.customReminder"
                          :options="optionsCustomReminder"
                          class="mb-3"
                          value-field="item"
                          text-field="name"
                        ></b-form-radio-group>
                      </div>
                      <div class="col-6 text-center">
                        <b-alert
                          variant="danger"
                          :show="action.customReminder != null"
                        >
                          <span v-if="action.customReminder === 'emailsms'">
                            Quando habilitado todo lembrete será enviado também
                            via SMS. É necessário ter saldo de SMS disponível!
                          </span>
                          <span v-else-if="action.customReminder === 'email'">
                            Quando habilitado todo lembrete será enviado via
                            Email. É necessário ter saldo de Email disponível!
                          </span>
                          <span v-else-if="action.customReminder === 'sms'">
                            Quando habilitado todo lembrete será enviado via
                            SMS. É necessário ter saldo de SMS disponível!
                          </span>
                        </b-alert>
                      </div>
                    </div>

                    <div v-if="action.customReminder">
                      <span>{{ $t('newAction.stepTwo.typeMesssage') }}:</span>
                      <b-input-group
                        append="https://id-cx.co/8dígitos"
                        class="mb-2 mr-sm-2 mb-sm-0"
                      >
                        <b-input
                          v-model="action.sms.msgLink"
                          id="message-link-id"
                          style="box-shadow: none"
                          placeholder="Responda a nossa pesquisa aqui:"
                          maxlength="130"
                        ></b-input>
                      </b-input-group>
                    </div>
                  </div> -->
                </idx-card>
              </div>
            </div>
            <div class="row">
              <div class="col-8">
                <idx-card
                  :title="`${this.$t(
                    'newAction.stepTwo.titleQuarantineSetting',
                  )}`"
                  class="mt-4"
                >
                  <div class="col-12" style="display: flex">
                    <div class="form-group">
                      <span>{{
                        $t('actionTranslateUpdate.quarentine.dispatch')
                      }}</span>
                      <b-form-checkbox
                        size="lg"
                        v-model="action.quarentine.activeSubmit"
                        name="check-shot"
                        switch
                      >
                      </b-form-checkbox>
                    </div>

                    <div
                      class="form-group"
                      style="margin-left: 1rem; white-space: nowrap"
                    >
                      <label for="quarentine"
                        >{{ $t('newAction.stepTwo.labels.periodDays') }}:</label
                      >
                      <b-form-select
                        class="optionsChoose"
                        v-model="selected"
                        :options="options"
                        @change="setQuarentineDays($event)"
                      ></b-form-select>
                    </div>

                    <div class="form-group" style="margin-left: 15px">
                      <label for="quarentine">{{
                        $t('actionTranslateUpdate.quarentine.validity')
                      }}</label>
                      <b-form-select
                        v-model="action.quarentine.expirationType"
                        :options="expirationTypeOptions"
                      ></b-form-select>
                    </div>
                  </div>

                  <div class="col-12" style="display: flex">
                    <div class="form-group">
                      <span>{{
                        $t('actionTranslateUpdate.quarentine.answer')
                      }}</span>
                      <b-form-checkbox
                        v-model="action.quarentine.activeAnswer"
                        size="lg"
                        name="check-shot"
                        switch
                      >
                      </b-form-checkbox>
                    </div>

                    <div
                      class="form-group"
                      style="margin-left: 15px; white-space: nowrap"
                    >
                      <label for="quarentine"
                        >{{ $t('newAction.stepTwo.labels.periodDays') }}:</label
                      >
                      <b-form-select
                        class="optionsChoose"
                        v-model="selectedAnswer"
                        :options="options"
                        @change="setQuarentineDaysAnswer($event)"
                      ></b-form-select>
                    </div>

                    <div class="form-group" style="margin-left: 15px">
                      <label for="quarentine">{{
                        $t('actionTranslateUpdate.quarentine.validity')
                      }}</label>
                      <b-form-select
                        v-model="action.quarentine.expirationTypeAnswer"
                        :options="expirationTypeOptions"
                      ></b-form-select>
                    </div>
                  </div>
                </idx-card>
              </div>
              <div class="col-4">
                <idx-card
                  :title="`${this.$t('newAction.stepTwo.titleExpirationDate')}`"
                  class="mt-4"
                >
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label for="expire"
                          >{{
                            $t('newAction.stepTwo.labels.expirationDays')
                          }}
                          :</label
                        >
                        <input
                          type="number"
                          class="form-control"
                          id="expire"
                          :value="action.alertRules.expire"
                          @keyup="setAlertRuleExpire($event.target.value)"
                        />
                        <p id="validate" style="display: none; color: red">
                          * {{ $t('newAction.stepTwo.mandatory') }}
                        </p>
                      </div>
                    </div>
                  </div>
                </idx-card>
              </div>
            </div>
          </div>
          <div :class="classReminders">
            <b-tabs content-class="mt-3">
              <b-tab title="Layout do alerta" active
                ><p>
                  <idx-card
                    :title="`${this.$t('newAction.stepTwo.titleModelAlert')}`"
                  >
                    <div
                      v-if="!action.multiLanguage"
                      class="col-12 text-center"
                    >
                      <label>
                        {{ $t('newAction.stepTwo.languageEmail') }}:</label
                      >
                      <b-dropdown class="text-center" id="select-language">
                        <template slot="button-content">
                          <country-flag
                            :country="action.langAlert"
                            size="normal"
                          />
                          {{ countryName }}
                        </template>
                        <b-dropdown-item @click="selectLang('Português')">
                          <country-flag country="br" size="normal" />
                          {{ this.$t('dashboard.portugues') }}
                        </b-dropdown-item>

                        <b-dropdown-item @click="selectLang('English')">
                          <country-flag country="us" size="normal" />
                          {{ this.$t('dashboard.ingles') }}
                        </b-dropdown-item>

                        <b-dropdown-item @click="selectLang('Español')">
                          <country-flag country="es" size="normal" />
                          {{ this.$t('dashboard.espanhol') }}
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <div v-else class="text-center">
                      <p style="font-size: 12px; color: red">
                        *{{ $t('newAction.stepTwo.infoAlert') }}.
                      </p>
                    </div>

                    <div class="row">
                      <div class="col-12 text-center">
                        <div class="form-group form-group-alert-title">
                          <label for="alert-title-id">{{ titleAlert }}</label>
                          <input
                            type="text"
                            class="form-control alert-title"
                            id="alert-title-id"
                            v-model="action.alertRules.title"
                          />
                          <div class="invalid-feedback">
                            {{ $t('newAction.stepTwo.feedbackEnterAlertName') }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 text-center">
                        <p class="mb-5 idx-bold">
                          {{ feedbackNewAlert }}
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4 mb-4">
                        <center>
                          <span class="idx-bold">{{ note }}</span>
                          <div class="flag-note mt-2">5</div>
                        </center>
                      </div>
                      <div class="col-lg-8">
                        <p class="idx-bold">
                          {{ actionTranslate }}:
                          {{ action.name }}
                        </p>

                        <span>João Cléber</span>
                        <br />
                        <span class="user-info"
                          >{{ channelTranslate }}:
                          {{ $t('newAction.stepTwo.email') }}</span
                        >
                        <br />
                        <span class="user-info"
                          >{{ $t('newAction.stepTwo.email') }}:
                          {{ $t('newAction.stepTwo.emailJoao') }}</span
                        >
                        <br />
                        <span class="user-info"
                          >{{ phoneTranslate }}:
                          {{ $t('newAction.stepTwo.phoneUser') }}</span
                        >
                        <br />
                        <br />

                        <p>{{ feedbackUserReport }}:</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 text-center">
                        <hr />
                        <span class="idx-bold">{{ messageTranslate }}:</span>
                        <br />
                        <span class="font-italic">{{
                          feedbackIncorrectProduct
                        }}</span>
                      </div>
                    </div>
                  </idx-card>
                </p></b-tab
              >
              <template v-if="action.channel !== 'click-to-call'">
                <b-tab
                  v-if="!action.multiLanguage || !action.enableTranslation"
                  title="Layout do lembrete"
                >
                  <div class="row">
                    <div class="col-8">
                      <div id="panel-template" class="panel-template">
                        <div
                          v-if="action.useLogo && action.channel !== 'widget'"
                          class="template-header"
                        >
                          <img
                            :src="
                              action.uploadedImage ? action.uploadedImage : logo
                            "
                          />
                        </div>

                        <div class="template-body">
                          <wysiwyg
                            api-key="no-api-key"
                            license_key="gpl2"
                            tinymceScriptSrc="https://tinymce5.s3.amazonaws.com/tinymce/tinymce.min.js"
                            :init="{
                              menubar: false,
                              statusbar: false,
                              height: 600,
                              language: $t('newAction.stepOne.editorLanguage'),
                              plugins: 'link image lists hr emoticons',
                              toolbar:
                                'bold italic underline | alignleft aligncenter alignright alignjustify | link image | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight | code',
                              lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
                              fontsize_formats:
                                '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
                              font_formats:
                                'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato;Roboto=Roboto, sans-serif;Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
                              image_description: false,
                              image_title: false,
                              content_style:
                                'img {max-width: 100%; max-height: 100%}',
                              image_dimensions: false,
                              file_picker_types: 'image',
                              content_style:
                                '@import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
                              images_upload_handler: imagesUploadHandlerBody,
                              file_picker_callback: function (cb, value, meta) {
                                uploadImgTinyMce(cb);
                              },
                            }"
                            v-model="action.alertRules.htmlReminder"
                          />
                        </div>
                      </div>
                    </div>
                    <div id="form-inputs" class="col-4">
                      <template id="inputs">
                        <input
                          type="text"
                          placeholder="Remetente"
                          class="form-control form-group"
                          v-model="action.alertRules.sender"
                        />
                        <input
                          type="text"
                          placeholder="Assunto"
                          class="form-control form-group"
                          v-model="action.alertRules.subject"
                        />
                      </template>

                      <button
                        v-if="panelLeft"
                        :title="`${this.$t('newAction.buttonReturn')}`"
                        class="btn btn-primary"
                        @click="expandPanelReminder"
                      >
                        <i class="fas fa-arrow-left"></i>
                      </button>

                      <button
                        v-b-modal="`modal-teste-template-reminder`"
                        :title="`${$t('newAction.stepOne.titleTestLayoutEmail')}`"
                        class="btn btn-primary"
                      >
                        <font-awesome-icon
                          :icon="['fas', 'paper-plane']"
                          style="font-size: 16px; margin-left: -2px;"
                        />
                      </button>
                      <ModalTesteTemplateReminder />
                      <button
                        v-if="panelRight"
                        :title="`${this.$t('newAction.buttonReturn')}`"
                        class="btn btn-primary"
                        @click="returnPanelReminder"
                      >
                        <i class="fas fa-arrow-right"></i>
                      </button>

                      <div style="margin-top: 20px;">
                        <span style="font-size: 15px;">Considerar este html no lembrete</span>
                        <b-form-checkbox v-model="action.alertRules.enableHTMLReminder" name="check-button-reminder" switch>
                          Habilitado
                        </b-form-checkbox>
                      </div>
                    </div>
                  </div>
                </b-tab>
              </template>
            </b-tabs>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-4 footer-buttons-area">
            <button @click="$router.back()" class="btn btn-info">
              {{ $t('genericMessages.goBack') }}
            </button>
            <div v-if="loadingSave">
              <b-spinner
                variant="primary"
                type="grow"
                class="align-middle"
              ></b-spinner>
            </div>
            <button v-else @click="saveAction" class="btn btn-info">
              {{ $t('newAction.stepOne.saveChanges') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IdxCard from '@/components/molecules/idx-card';
import swal from 'sweetalert';
import vueStep from 'vue-step';
import CountryFlag from 'vue-country-flag';
import ModalEditRule from '@/components/molecules/modal-edit-rule';
import ModalEditRuleKeyword from '@/components/molecules/modal-new-rule-keyword-edit';
import ModalNewRule from '@/components/molecules/modal-new-rule';
import ModalTesteTemplateReminder from '@/components/molecules/modal-teste-template-reminder';
import ModalNewRuleKeyword from '@/components/molecules/modal-new-rule-keyword';
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { format } from 'date-fns';
import pt from 'date-fns/locale/pt';
import api from '../../../../services/api';
import EventBus from '../../../../eventBus';

export default {
  components: {
    IdxCard,
    ModalEditRule,
    ModalNewRule,
    vueStep,
    CountryFlag,
    ModalNewRuleKeyword,
    ModalEditRuleKeyword,
    ModalTesteTemplateReminder
  },

  data: () => ({
    loading: false,
    userAuth: null,
    ruleName: null,
    ruleNameByKeyword: null,
    fields: [],
    fieldsKeywords: [],
    selected: 0,
    selectedAnswer: 0,
    options: [],
    quarentineType: 'none',
    quarentineOptions: [],
    expirationType: 'company',
    expirationTypeOptions: [],
    timeSelected: '12:00',
    timeOptions: [
      { value: '00:00', text: '00:00' },
      { value: '00:30', text: '00:30' },
      { value: '01:00', text: '01:00' },
      { value: '01:30', text: '01:30' },
      { value: '02:00', text: '02:00' },
      { value: '02:30', text: '02:30' },
      { value: '03:00', text: '03:00' },
      { value: '03:30', text: '03:30' },
      { value: '04:00', text: '04:00' },
      { value: '04:30', text: '04:30' },
      { value: '05:00', text: '05:00' },
      { value: '05:30', text: '05:30' },
      { value: '06:00', text: '06:00' },
      { value: '06:30', text: '06:30' },
      { value: '07:00', text: '07:00' },
      { value: '07:30', text: '07:30' },
      { value: '08:00', text: '08:00' },
      { value: '08:30', text: '08:30' },
      { value: '09:00', text: '09:00' },
      { value: '09:30', text: '09:30' },
      { value: '10:00', text: '10:00' },
      { value: '10:30', text: '10:30' },
      { value: '11:00', text: '11:00' },
      { value: '11:30', text: '11:30' },
      { value: '12:00', text: '12:00' },
      { value: '12:30', text: '12:30' },
      { value: '13:00', text: '13:00' },
      { value: '13:30', text: '13:30' },
      { value: '14:00', text: '14:00' },
      { value: '14:30', text: '14:30' },
      { value: '15:00', text: '15:00' },
      { value: '15:30', text: '15:30' },
      { value: '16:00', text: '16:00' },
      { value: '16:30', text: '16:30' },
      { value: '17:00', text: '17:00' },
      { value: '17:30', text: '17:30' },
      { value: '18:00', text: '18:00' },
      { value: '18:30', text: '18:30' },
      { value: '19:00', text: '19:00' },
      { value: '19:30', text: '19:30' },
      { value: '20:00', text: '20:00' },
      { value: '20:30', text: '20:30' },
      { value: '21:00', text: '21:00' },
      { value: '21:30', text: '21:30' },
      { value: '22:00', text: '22:00' },
      { value: '22:30', text: '22:30' },
      { value: '23:00', text: '23:00' },
      { value: '23:30', text: '23:30' },
    ],
    loadingSave: false,
    optionsRadio: [
      { item: false, name: 'Não' },
      { item: true, name: 'Sim' },
    ],
    optionsCustomReminder: [
      { item: 'email', name: 'E-mail' },
      { item: 'emailsms', name: 'E-mail/SMS' },
      { item: 'sms', name: 'SMS' },
    ],
    smsReminder: false,
    logo: null,
    panelLeft: true,
    panelRight: false,
    classReminders: 'col-lg-6',
    classConfigs: 'col-lg-6',
    htmlReminder: '',
    enableCustomReminder: false,
    countryName: 'Português',
    country: 'br',
    feedbackNewAlert: 'Você recebeu um novo alerta!',
    titleAlert: 'Título do Alerta',
    note: 'Nota',
    actionTranslate: 'Ação',
    channelTranslate: 'Canal',
    phoneTranslate: 'Telefone',
    feedbackUserReport: 'O usuário abaixo reportou o seguinte feedback',
    messageTranslate: 'Mensagem',
    feedbackIncorrectProduct:
      'Não recebi o produto correto e estou bem chateado!',
    listRuleByKeywords: [
    ],
    loadingRuleKeyword: true,
  }),

  computed: {
    ...mapState('alertRules', ['listRules', 'alertCount', 'loadingModalRule']),
    ...mapFields('actions', ['action']),
    ...mapState('companies', ['company']),
  },

  methods: {
    ...mapActions('alertRules', ['setList']),
    ...mapActions('settings', ['getAllUsers']),
    ...mapActions('actions', [
      'setAlertRuleId',
      'setKeywordRuleId',
      'setAlertRuleQuarentine',
      'setQuarentineType',
      'setQuarentineDays',
      'setQuarentineDaysAnswer',
      'setAlertRuleExpire',
      'setAlertRuleReminders',
      'setAlertRuleTime',
      'setAlertRuleInterval',
      'setAlertRuleTitle',
      'updateAction',
    ]),

    getV3() {
      const userAuth = JSON.parse(localStorage.getItem('_indecx'));
      const token = userAuth.token;
      const host = window.location.host;
      const url = (host.includes('indecx.pe')) ? `https://stg.app-indecx.com/redirect/${token}` : `https://v3.app-indecx.com/redirect/${token}`;
      window.location.href = url;
    },

    getDataRule(idRule) {
      EventBus.$emit('get-data-rule', idRule._id);
    },

    selectLang(country) {
      if (country === 'Português') {
        this.countryName = country;
        this.country = 'br';
        this.action.langAlert = 'br';
      } else if (country === 'English') {
        this.countryName = country;
        this.country = 'us';
        this.action.langAlert = 'us';
      } else {
        this.countryName = country;
        this.country = 'es';
        this.action.langAlert = 'es';
      }

      this.translateAlert(this.country);
    },

    uploadImgTinyMce(cb) {
      const $input = document.createElement('input');
      $input.setAttribute('type', 'file');
      $input.setAttribute('accept', 'image/*');
      // this.uploadedImageURL = this.image;
      $input.onchange = function onChangeImg() {
        const file = this.files[0];
        const reader = new FileReader();
        reader.onload = function readerImg() {
          const id = `blobid${new Date().getTime()}`;
          const blobCache = window.tinymce.activeEditor.editorUpload.blobCache;
          const base64 = reader.result.split(',')[1];
          const blobInfo = blobCache.create(id, file, base64);
          blobCache.add(blobInfo);
          cb(blobInfo.blobUri(), { title: file.name });
        };
        reader.readAsDataURL(file);
      };
      $input.click();
    },

    expandPanelReminder() {
      this.panelLeft = false;
      this.panelRight = true;
      this.classReminders = 'col-lg-12';
      this.classConfigs = 'hide-configs';
    },

    returnPanelReminder() {
      this.panelLeft = true;
      this.panelRight = false;
      this.classReminders = 'col-lg-6';
      this.classConfigs = 'col-lg-6';
    },

    imagesUploadHandlerBody(blobInfo, success, failure) {
      if (blobInfo) {
        const xhr = new XMLHttpRequest();

        xhr.withCredentials = false;
        xhr.open('POST', `${process.env.API_ROOT}/image-body/action`);
        xhr.setRequestHeader('x-access-token', this.userAuth.token);
        xhr.onload = function analise() {
          if (xhr.status !== 200) {
            failure(`HTTP Error: ${xhr.status}`);
            return;
          }
          const json = JSON.parse(xhr.responseText);
          if (!json || typeof json !== 'string') {
            failure(`Invalid JSON: ${xhr.responseText}`);
            return;
          }
          success(json);
        };
        const formData = new FormData();
        formData.append('file', blobInfo.blob(), blobInfo.filename());
        xhr.send(formData);
      }
    },

    chooseRule(id, ruleIndex, none) {
      if (none) {
        this.setAlertRuleId(null);
        this.ruleName = null;
      } else {
        this.setAlertRuleId(id);
        this.ruleName = this.listRules[ruleIndex].name;
      }
    },

    chooseRuleKeywords(id, ruleIndex, none) {
      if (none) {
        this.ruleNameByKeyword = null;
        this.action.keywordsAlertId = null;
        this.getDataRuleByKeyword();
      } else {
        this.action.keywordsAlertId = id;
        this.listRuleByKeywords.forEach((el) => {
          if (el._id === this.action.keywordsAlertId) {
            this.ruleNameByKeyword = el.ruleName;
          }
        });
      }
    },

    dateFormat(param) {
      const date = format(param, 'dd/MM/yyyy', { locale: pt });
      return date;
    },

    async saveAction() {
      this.loadingSave = true;

      try {
        if (this.action.alertRules.expire) {
          await this.updateAction({
            token: this.userAuth.token,
            id: this.action._id,
            data: {
              alertRules: {
                ...this.action.alertRules,
                title: document.getElementById('alert-title-id').value,
                reminders: this.action.alertRules.reminders
                  ? this.action.alertRules.reminders
                  : '0',
                interval: this.action.alertRules.interval
                  ? this.action.alertRules.interval
                  : '0',
              },
              quarentine: this.action.quarentine,
              sms: {
                config: this.action.sms.config
                  ? this.action.sms.config
                  : 'link',
                msgLink: this.action.sms.msgLink,
              },
              smsReminder: this.smsReminder,
              customReminder: this.action.customReminder,
              langAlert: this.action.langAlert,
              keywordsAlertId: this.action.keywordsAlertId
            },
          });

          swal({
            title: this.$t('newAction.stepThree.settingsSaved'),
            text: this.$t('newAction.stepThree.wish'),
            icon: 'success',
            buttons: {
              leave: {
                text: this.$t('newAction.stepThree.continueAfter'),
                value: 'leave',
              },
              next: {
                text: this.$t('newAction.stepThree.skipImport'),
                value: 'next',
              },
            },
          }).then((value) => {
            if (value === 'next') {
              if (this.action.channel === 'qrcode') {
                this.$router.push(`/action/prepare-qr-code/${this.action._id}`);
              } else if (this.action.channel === 'link') {
                this.$router.push(`/action/link/${this.action._id}`);
              } else if (this.action.channel === 'totem') {
                this.$router.push(`/action/link/${this.action._id}`);
              } else {
                this.$router.push(`/action/importation/${this.action._id}`);
              }
            } else if (value === 'leave') {
              this.$router.push('/action-list');
            }
          });
        } else {
          document.querySelector('#validate').style.display = 'block';
        }
      } catch (error) {
        swal({
          title: this.$t('newAction.stepOne.messageError.title'),
          text: this.$t('newAction.stepOne.messageError.errorEditAction'),
          icon: 'error',
        });
      }
      this.loadingSave = false;
    },

    translateAlert(lang) {
      if (lang === 'br') {
        this.feedbackNewAlert = 'Você recebeu um novo alerta!';
        this.titleAlert = 'Título do Alerta';
        this.note = 'Nota';
        this.actionTranslate = 'Ação';
        this.channelTranslate = 'Canal';
        this.phoneTranslate = 'Telefone';
        this.feedbackUserReport =
          'O usuário abaixo reportou o seguinte feedback';
        this.messageTranslate = 'Mensagem';
        this.feedbackIncorrectProduct =
          'Não recebi o produto correto e estou bem chateado!';
      } else if (lang === 'us') {
        this.feedbackNewAlert = 'You have received a new alert!';
        this.titleAlert = 'Alert Title';
        this.note = 'Note';
        this.actionTranslate = 'Action';
        this.channelTranslate = 'Channel';
        this.phoneTranslate = 'Phone';
        this.feedbackUserReport =
          'The user below has reported the following feedback';
        this.messageTranslate = 'Message';
        this.feedbackIncorrectProduct =
          'I didnt receive the correct product and I am very upset!';
      } else {
        this.feedbackNewAlert = 'Usted recibió un nuevo alerta!';
        this.titleAlert = 'Título del Alerta';
        this.note = 'Nota';
        this.actionTranslate = 'Acción';
        this.channelTranslate = 'Canal';
        this.phoneTranslate = 'Teléfono';
        this.feedbackUserReport =
          'El siguiente usuario ha informado los siguientes comentarios';
        this.messageTranslate = 'Mensaje';
        this.feedbackIncorrectProduct =
          '¡No recibí el producto correcto y estoy muy molesto!';
      }
    },

    async getDataRuleByKeyword(){
      this.loadingRuleKeyword = true;
      const response = await api.get(`/keywords-alert/${this.userAuth.companyId}`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
         params: {
        },
      });

      this.listRuleByKeywords = response.data.listRuleByKeywords;
      this.loadingRuleKeyword = false;
    }
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    const response = await api.get(`/action/${this.$route.params.id}`, {
      headers: {
        'x-access-token': this.userAuth.token,
      },
    });

    this.action = { ...response.data };

    this.action.langAlert = this.action.langAlert
      ? this.action.langAlert
      : 'br';

    if (this.action.langAlert === 'br') {
      this.countryName = 'Português';
    } else if (this.action.langAlert === 'us') {
      this.countryName = 'English';
    } else {
      this.countryName = 'Espanõl';
    }

    this.translateAlert(this.action.langAlert);

    this.action.alertRules.htmlReminder = this.action.alertRules.htmlReminder
      ? this.action.alertRules.htmlReminder
      : this.action.email.template.myHTML;

    this.action.alertRules.sender = this.action.alertRules.sender
      ? this.action.alertRules.sender
      : this.action.email.from;

    this.action.alertRules.subject = this.action.alertRules.subject
      ? this.action.alertRules.subject
      : `${this.action.email.subject ? `${this.action.email.subject}` : ''}`;

    if (this.action.customReminder !== null) {
      this.enableCustomReminder = true;
    } else {
      this.enableCustomReminder = false;
    }

    this.fields = [
      { key: '_id', label: '' },
      {
        key: 'name',
        label: this.$t('newAction.stepTwo.labels.ruleName'),
        sortable: true,
      },
      {
        key: 'createdAt',
        label: this.$t('newAction.stepTwo.labels.creationDate'),
        sortable: true,
      },
      {
        key: 'action',
        label: this.$t('newAction.stepTwo.labels.actions'),
        sortable: true,
      },
    ];

    this.fieldsKeywords = [
      { key: '_id', label: '' },
      {
        key: 'ruleName',
        label: this.$t('newAction.stepTwo.labels.ruleName'),
        sortable: true,
      },
      {
        key: 'createdAt',
        label: this.$t('newAction.stepTwo.labels.creationDate'),
        sortable: true,
      },
      {
        key: 'action',
        label: this.$t('newAction.stepTwo.labels.actions'),
        sortable: true,
      },
    ];

    this.options = [
      { value: 0, text: this.$t('newAction.stepTwo.noOption') },
      { value: 1, text: '1' },
      { value: 3, text: '3' },
      { value: 7, text: '7' },
      { value: 15, text: '15' },
      { value: 20, text: '20' },
      { value: 30, text: '30' },
      { value: 45, text: '45' },
      { value: 50, text: '50' },
      { value: 60, text: '60' },
      { value: 90, text: '90' },
      { value: 120, text: '120' },
      { value: 180, text: '180' },
    ];

    this.quarentineOptions = [
      { value: 'none', text: this.$t('newAction.stepTwo.noOption') },
      { value: 'submit', text: this.$t('newAction.stepTwo.shoot') },
      { value: 'answer', text: this.$t('newAction.stepTwo.answer') },
      { value: 'actionGroup', text: this.$t('newAction.stepTwo.actionGroup') },
    ];

    this.expirationTypeOptions = [
      {
        value: 'company',
        text: this.$t('actionTranslateUpdate.quarentine.options.allData'),
      },
      {
        value: 'action',
        text: this.$t('actionTranslateUpdate.quarentine.options.thisAction'),
      },
      {
        value: 'actionGroup',
        text: this.$t('actionTranslateUpdate.quarentine.options.actionGroup'),
      },
    ];
  },

  async mounted() {
    this.selected = this.action.quarentine.days;
    this.selectedAnswer = this.action.quarentine.daysAnswer;
    this.quarentineType = this.action.quarentine.type;
    this.timeSelected = this.action.alertRules.time || '12:00';

    const logoUrl = process.env.INDECX_FILES_BUCKET;
    this.getDataRuleByKeyword();

    EventBus.$on('update-table-rule-keyword', async () => {
      await this.getDataRuleByKeyword();
    });

    if (this.action.useLogo) {
      if (this.action.uploadedImage) {
        this.logo = this.action.uploadedImage;
      } else if (this.action.logo) {
        this.logo = `${logoUrl}/${this.action.logo}`;
      } else {
        this.logo = `${logoUrl}/${this.company.logo}`;
      }
    }

    this.smsReminder = this.action.smsReminder
      ? this.action.smsReminder
      : false;

    this.action.alertRules.htmlReminder = this.action.alertRules.htmlReminder
      ? this.action.alertRules.htmlReminder
      : this.action.email.template.myHTML;

    this.action.alertRules.enableHTMLReminder = this.action.alertRules.enableHTMLReminder
      ? this.action.alertRules.enableHTMLReminder
      : false;

    this.loading = true;

    await this.setList({
      companyId: this.userAuth.companyId,
      token: this.userAuth.token,
    });

    await this.getAllUsers({
      companyId: this.userAuth.companyId,
      token: this.userAuth.token,
      userId: this.userAuth._id,
    });

    this.listRules.forEach((el) => {
      if (el._id === this.action.alertRules.id) {
        this.ruleName = el.name;
      }
    });

    this.listRuleByKeywords.forEach((el) => {
      if (el._id === this.action.keywordsAlertId) {
        this.ruleNameByKeyword = el.ruleName;
      }
    });

    this.$store.state.alertRules.loadingModalRule = false;

    this.loading = false;
  },
  watch: {
    enableCustomReminder: function watchEnableCustomReminder(value) {
      if (value) {
        this.action.customReminder = this.action.customReminder || 'email';
      } else {
        this.action.customReminder = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.form-group,
.optionsChoose {
  display: block;
}
.template-header {
  border: 1px dashed $gray;
  padding: 10px;
  text-align: center;
  img {
    height: 70px;
  }
}

.msg-reminder {
  border-width: 1px;
  border-style: solid;
  border-color: #b15b70;
  border-radius: 10px;
  background: #f1dddd;
  color: #b15b70;
}

.wrapper {
  background-color: #fff;
  border: 1px solid $gray-light;
  padding: 8px 24px;
  border-radius: 4px;
  margin: 8px;
}

.vue-step-wrapper {
  background-color: #fff;
  border: 1px solid $gray-light;
  padding: 0 24px;
  border-radius: 4px;
  margin: 8px 8px 16px;
}

.loading-area {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 200px);
}

.alert-title {
  max-width: 500px;
}

.hide-configs {
  display: none;
}

.form-group-alert-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.flag-note {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 24px;
  width: 100px;
  height: 100px;
  border-radius: 50px;
  color: $white;
  background-color: red;
}

.user-info {
  color: rgb(133, 131, 131);
  font-style: italic;
}

.btn {
  &:hover {
    color: $white;
  }
}

.footer-buttons-area {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>

<style lang="scss">
.table-step-two {
  min-height: 191px;
  max-height: 191px;
  overflow: auto;
  table {
    thead {
      tr {
        th {
          font-size: 15px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/actions/step-two/index.vue